import { render, staticRenderFns } from "./ImportData.vue?vue&type=template&id=b86ec096&scoped=true&"
import script from "./ImportData.vue?vue&type=script&lang=ts&"
export * from "./ImportData.vue?vue&type=script&lang=ts&"
import style0 from "./ImportData.vue?vue&type=style&index=0&id=b86ec096&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86ec096",
  null
  
)

export default component.exports